/* INDUSTRIBRANCHEN - TEMA 3 */
const gameSteps = [
	{
		id: 'theme-1-3-video1',
		type: 'video',
		title: {
			da: `Se filmen sammen`,
			en: `Watch the video together`
		},
		videos: [
			{id: {da: 'zgkZISAo6G8', en: 'yX80u8EhmvQ'}, thumbnail: 'theme-1-3-video1'}
		],
		nextBtn: null,
		nextBtnConditions: []
	},
	{
		id: 'theme-1-3-question1',
		type: 'questions',
		title: {
			da: 'Vælg en handling',
			en: `Choose an action`
		},
		text: {
			da: `Hvad synes I Jonas skal gøre?`,
			en: `What do you think Jonas should do?`
		},
		nextBtn: null,
		questions: [
			{
				id: 'theme-1-3-question1-question',
				type: 'multiple-choice',
				options: [
					{
						id: 1,
						text: {
							da: `Jonas skal tale med Anne om fejl, så de sammen kan finde en måde at undgå dem på.`,
							en: `Jonas should talk to Anne about making mistakes. Then they can find a way of avoiding them together.`
						},
					},
					{
						id: 2,
						text: {
							da: `Jonas skal tage fat i Emma, så han kan påvirke hende til at give Anne konstruktiv feedback.`,
							en: `Jonas should talk to Emma about giving constructive feedback to Anne.`
						}
					},
				]
			}
		]
	},
	{
		id: 'theme-1-3-video2',
		type: 'video',
		title: {
			da: `Se filmen sammen`,
			en: `Watch the video together`
		},
		videos: [
			{
				id: {da: '0nh1LWqDxfQ', en: 'S-JeBFK1enU'}, 
				thumbnail: 'theme-1-3-video2a',
				conditions: [{type: 'question-option-selected', questionId: 'theme-1-3-question1-question', optionId: 1}]
			},
			{
				id: {da: 'x62pNypZrM8', en: 'K86znnzzSDY'}, 
				thumbnail: 'theme-1-3-video2b',
				conditions: [{type: 'question-option-selected', questionId: 'theme-1-3-question1-question', optionId: 2}]
			},
		],
		nextBtn: null,
		nextBtnConditions: []
	},
	{
		id: 'theme-1-3-dilemma',
		type: 'questions',
		subtype: 'dilemma',
		title: {
			da: 'Tal i gruppen',
			en: `Discuss in your group`
		},
		text: {
			da: `Forestil jer, at Emma et par dage senere oplever, at Anne igen laver lignende fejl. Hvad skal hun gøre for at håndtere det på en god måde?
				<br /><br />Tal om det i gruppen, og vælg en mulighed.`,
			en: `Imagine that, a few days later, Emma notices that Anne is making similar mistakes again. What should she do to handle the situation appropriately?
				<br /><br /> Discuss this in the group and choose one option.`
		},
		nextBtn: null,
		questions: [
			{
				id: 'theme-1-3-dilemma-question',
				type: 'multiple-choice',
				subtype: 'dilemma',
				options: [
					{
						id: 1,
						text: {
							da: `Emma skal referere til deres samtale og spørge, hvad Anne gør for at undgå dem.`,
							en: `Emma should refer to their conversation and ask what Anne is doing to avoid mistakes.`
						},
					},
					{
						id: 2,
						text: {
							da: `Emma skal spørge, hvad Anne har brug for for at kunne undgå at lave fejl.`,
							en: `Emma should ask what Anne needs in order to avoid mistakes.`
						}
					},
					{
						id: 3,
						text: {
							da: `Emma skal tale med sit team om deres arbejdsgange. Fejlene kan være et symptom på andre problemer.`,
							en: `Emma should talk to her team about their routines. Maybe the mistakes are a symptom of other issues.`
						}
					}
				]
			}
		]
	},
	// {
	// 	id: 'theme-1-3-dilemma-result',
	// 	type: 'dilemma-result',
	// 	dilemmaGameStepId: 'theme-1-3-dilemma',
	// 	dilemmaQuestionId: 'theme-1-3-dilemma-question',
	// 	title: {
	// 		da: 'Andre, der har prøvet forløbet, har svaret:',
	// 		en: `Others who've used this tool have answered:`
	// 	},
	// 	nextBtn: {
	// 		da: 'Videre',
	// 		en: 'Next'
	// 	}
	// },
	{
		id: 'theme-1-3-discussion',
		type: 'text',
		title: {
			da: 'Jeres arbejdsplads',
			en: `Your workplace`
		},
		text1: {
			da: `Hvordan vil I gerne have, at jeres kollegaer reagerer, når I begår fejl?`,
			en: `How would you like your colleagues to react when you make a mistake?`
		},
		text2: {
			da: `Tal om det i gruppen i tre-fem minutter, og tryk så "Videre".`,
			en: ` Discuss this in the group for three to five minutes, then click "Next".`
		},
		nextBtn: {
			da: 'Videre',
			en: 'Next'
		},
		nextBtnConditions: [],
	},
	{
		id: 'theme-1-3-survey',
		type: 'survey',
		title: {
			da: 'Individuelle spørgsmål',
			en: `Individual questions`
		},
		text: {
			da: `I skal nu svare individuelt på nogle spørgsmål. Scan koden med jeres egne telefoner. Når alle spillere har scannet QR-koden, skal spilleren med denne telefon trykke "Videre" for at gå til de individuelle spørgsmål.`,
			en: `You will now answer some questions individually. Scan the code using your own phones. Once all players have scanned the QR code, the player with this phone should tap "Next" to proceed to the individual questions.`
		},
		questions: [
			{ 
				id: 'theme-1-3-survey-q1',
				type: 'multiple-choice',
				// title: {
				// 	da: 'Spørgsmål 1'
				// 	en: 'Question 1'
				// },
				text: {
					da: `Hvad er de største udfordringer på din arbejdsplads, når der sker fejl?
						<br /><br /><strong>Vælg 1 eller 2 svar og tryk så "Videre".</strong>`,
					en: `What are the biggest challenges in your place of work when mistakes happen?
						<br /><br /><strong>Choose 1 or 2 answers and then press "Next".</strong>`
				},
				maxNumberOfAnswers: 2,
				options: [
					{
						id: 1,
						text: {
							da: `Vi er mere optaget af, hvem der har skylden, end hvad vi kan lære af fejlen.`,
							en: `We focus on assigning blame instead of what we can learn from the mistake.`
						},
					},
					{
						id: 2,
						text: {
							da: `Fejl bliver sjældent brugt som noget, vi kan lære af.`,
							en: `Mistakes are rarely seen as something we can learn from.`
						}
					},
					{
						id: 3,
						text: {
							da: `Når vi er åbne om, at vi har lavet en fejl, skaber det dårlig stemning.`,
							en: `When we are honest about having made mistakes, it creates a bad mood.`
						}
					},
					{
						id: 4,
						text: {
							da: `Man føler sig dum eller utilstrækkelig, når man laver en fejl.`,
							en: `You feel stupid or inadequate when you've made a mistake.`
						}
					},
					{
						id: 5,
						text: {
							da: `Der er ikke tid eller rum til at stoppe op og reflektere over fejl og rette op på det.`,
							en: `There aren't time or the space to stop and consider a mistake to correct it.`
						}
					},
					{
						id: 6,
						text: {
							da: `Fejl bliver gentaget, fordi vi ikke får talt om dem.`,
							en: `Mistakes are repeated because we don't talk about them.`
						}
					}
				]
			},
			{ 
				id: 'theme-1-3-survey-q2',
				type: 'multiple-choice',
				// title: {
				// 	da: 'Spørgsmål 2'
				// 	en: 'Question 2'
				// },
				text: {
					da: `Hvad er vigtigst for dig, når der sker fejl på din arbejdsplads?
 						<br /><br /><strong>Vælg 1 eller 2 svar og tryk så "Videre".</strong>`,
					en: `What is most important for you when mistakes happen in your place of work?
						<br /><br /><strong>Choose 1 or 2 answers and then press "Next".</strong>`
				},
				maxNumberOfAnswers: 2,
				options: [
					{
						id: 1,
						text: {
							da: `At vi taler åbent om fejl uden at pege fingre.`,
							en: `That we can talk openly about mistakes without pointing fingers.`
						},
					},
					{
						id: 2,
						text: {
							da: `At vi holder den gode tone, når der laves fejl.`,
							en: `That we maintain a professional tone when mistakes are made.`
						}
					},
					{
						id: 3,
						text: {
							da: `At vi hjælper hinanden, når noget går galt.`,
							en: `That we help each other when something goes wrong.`
						}
					},
					{
						id: 4,
						text: {
							da: `At man tør sige det, når man selv har lavet en fejl.`,
							en: `That you aren't afraid to share, if you've made a mistake.`
						}
					},
					{
						id: 5,
						text: {
							da: `At vi ikke bare retter fejl, men hjælper hinanden til at lære af dem.`,
							en: `That we don't just correct mistakes, but help each other to learn from them.`
						}
					},
					{
						id: 6,
						text: {
							da: `At fejl ikke bliver brugt imod én senere.`,
							en: `That mistakes aren't held against you at a later time.`
						}
					}
				]
			},
		],
		finishedTitle: {
			da: `Tak for dine svar!`,
			en: `Thank you for answering!`
		},
		finishedText: {
			da: `Øvelsen er nu slut. Gå tilbage til start-lokalet.`,
			en: `The exercise is now over. Please return to the starting room.`
		},
		nextBtn: {
			da: 'Videre',
			en: 'Next'
		},
	}
];
	

export {
	gameSteps
};